import { AxiosService } from '@/shared/utils'
import { AxiosRequestConfig } from 'axios'

class ReportsApi extends AxiosService {
  constructor(config?: AxiosRequestConfig) {
    super(config)
  }

  public getAdminReports(page: number) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/reports',
      params: {
        page,
      },
    })
  }
}

export const reportsApi = new ReportsApi({
  baseURL:
    process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URI : '',
  withCredentials: true,
})
